import { formatISO, parseISO } from "date-fns";
import {
    addTimeZoneOffset,
    formatDateForTransaction,
    formatDateOnly,
} from "@helpers/date";

/** Accrual documents expose dates as ISO strings from the API and as `Date` once hydrated. */
export type DateOrString = Date | string;

function toDate(value: DateOrString): Date {
    return typeof value === "string" ? parseISO(value) : value;
}

export function formatDateOrString(value: DateOrString): string {
    if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
        return formatDateOnly(value);
    }
    return formatDateForTransaction(addTimeZoneOffset(toDate(value)));
}

export function getDateInputValue(
    value: DateOrString | null | undefined,
): string {
    if (!value) {
        return "";
    }
    // Always normalize to YYYY-MM-DD. DatePicker rejects full ISO datetimes,
    // and invoice.due can arrive as either a Date or an ISO string.
    if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
        return value;
    }
    return formatISO(addTimeZoneOffset(toDate(value)), {
        representation: "date",
    });
}
